export const isNumeric = (x: string | number) => !isNaN(Number(x)) && !isNaN(parseFloat(String(x)));
